import axios from 'utils/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash';

const urls = {
  getAllRatingandReviews: '/store/allReviews',
  updateReview: '/store'
};

export const getAllRatingandReviewsApi = createAsyncThunk(
  'serviceplug/getAllRatingandReviewsApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.get(urls.getAllRatingandReviews, { params });
      if (response.data?.result) {
        return response.data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong with this');
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
export const getStoreReview = createAsyncThunk('serviceplug/getStoreReview', async (params, thunkApi) => {
  try {
    const response = await axios.get(`/store/${params.storeId}/reviews`, {
      params: { pageNo: params.pageNo, pageSize: params.pageSize }
    });
    if (response.data?.result) {
      return {
        result: response.data?.result,
        isAppend: params.isAppend,
        hasMoreReviewData: _.isArray(response.data?.result) && response.data?.result?.length > 9
      };
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const updateReviewApi = createAsyncThunk('serviceplug/updateReviewApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.updateReview}/${params._id}`,
      method: 'put',
      data: params
    });
    const data = await response.data;
    if (data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});
